import { deepInflate } from '~/util/inflate'
import { schemaFactory } from './storySchema'
import ArcUUID from '~/util/arc-identifiers'

export default function storyInflate(story) {
  const inflated = deepInflate(story, schemaFactory())
  return inflated
}

export function contentElementInflate(elem) {
  return deepInflate(elem, {
    // As we deprecate ArcUUID service it's cheap to assing new id here
    _id: elem._id || ArcUUID.create(),
    additional_properties: {
      _id: ArcUUID.create(),
      comments: [],
    },
  })
}

export function commentInflate(comments = []) {
  return deepInflate(
    {
      content_elements: [
        {
          additional_properties: { comments },
        },
      ],
    },
    schemaFactory()
  ).content_elements[0].additional_properties.comments
}
